import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from './modal';
import {MessageBoxTypes} from "@modules/testResults/const/TestResultsConst";
import { Button } from '@common/components/Button';

export class MessageBox extends Component {
    static defaultProps = {
        callback: () => {},
        cancelBtnId: 'btn-msg-cancel',
        confirmBtnId: 'btn-msg-ok',
        additionalBtnId: 'btn-msg-additional',
    };

    constructor(props) {
        super(props);
        this.onInputValueChange = this.onInputValueChange.bind(this);
    }

    onInputValueChange(e) {
        this.props.onInputValueChange(e.target.value)
    }

    onCancel = () => {
        const { hideMessageBox, onCustomCancel, type, data, callback } = this.props;

        callback(false);
        if (onCustomCancel) {
            onCustomCancel(type, data);
        }
        hideMessageBox(type, data);
    }

    onSubmit = () => {
        const { onCustomOk, type, data, callback } = this.props;

        callback(true);
        onCustomOk(type, data);
    }

    onAdditional = () => {
        const { onAdditional, type, data, callback } = this.props;

        callback(undefined);
        onAdditional(type, data);
    }

    render() {
        let className = "";
        let modalStyle = {top: '30%'};
        let headerStyle = {color: '#fff', borderBottom: '1px solid #e5e5e5', backgroundColor: '#008dce', borderRadius: '4px 4px 0px 0px', padding: '10px 15px'};
        let titleStyle = {color: 'white', margin: '0px', lineHeight: '1.42857143', fontSize: '15px', fontWeight: '400'};
        let bodyStyle = {fontSize: '15px'};
        let footerStyle = {borderTop: 'none'};
        let inputStyle = {marginTop: '10px', textAlign: 'center'};
        let btnNoStyle = {};

        if (this.props.type === MessageBoxTypes.AMBRY_KEYS) {
            className = "ambry-keys-setup-dialog";
            modalStyle = {top: '30%'};
            headerStyle = {};
            titleStyle = {color: 'white', fontSize: '18px', lineHeight: '1.42857143', fontWeight: 'normal'};
            footerStyle = {};
            btnNoStyle = {width: '100px'};
        }

        const { content, cancelBtnId, confirmBtnId, additionalBtnId } = this.props;

        return (
            <Modal bsSize={this.props.size}
                   bsClass="bootstrap modal"
                   show={this.props.show}
                   onHide={this.props.hideMessageBox}
                   animation={false}
                   backdrop='static'
                   style={modalStyle}
                   backdropStyle={{zIndex: 1050}}
                   dialogClassName={className}>
                <ModalHeader style={headerStyle}>
                    <ModalTitle id="msg-box-header" style={titleStyle}>{this.props.header}</ModalTitle>
                </ModalHeader>
                <ModalBody style={bodyStyle}>
                    <div dangerouslySetInnerHTML={{__html: this.props.text}} />
                    {content}
                    {this.props.showInput &&
                     <input id="tx-show-input" type='text' className='form-control' style={inputStyle} onBlur={this.onInputValueChange}/>
                    }
                </ModalBody>
                <ModalFooter style={footerStyle}>
                    {this.props.cancelText &&
                    <Button id={cancelBtnId} key="modalNo" onClick={this.onCancel} style={btnNoStyle}>{this.props.cancelText}</Button>
                    }
                    {this.props.additionalText &&
                    <Button id={additionalBtnId} key="modalAdditional" onClick={this.onAdditional} style={btnNoStyle}>{this.props.additionalText}</Button>
                    }
                    {this.props.confirmText &&
                    <Button id={confirmBtnId} key="modalOk" type="submit" className="btn btn-primary"
                            onClick={this.onSubmit}>{this.props.confirmText}</Button>
                    }
                </ModalFooter>
            </Modal>
        )
    }

}

MessageBox.propTypes = {
    type: PropTypes.string,
    header: PropTypes.string,
    text: PropTypes.string,
    showInput: PropTypes.bool,
    onInputValueChange: PropTypes.func,
    show: PropTypes.bool,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    size: PropTypes.string,
    hideMessageBox: PropTypes.func,
    onCustomOk: PropTypes.func,
    onCustomCancel: PropTypes.func,
    data: PropTypes.object,
    callback: PropTypes.func,
};

